import { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useDomFieldName, useDomFieldId } from './_useFieldName';
import { FIELD_AUTOCOMPLETE_OFF } from './_fieldDefaults';

const BLOCK = 'LStudio__app_field';

/*
    🔥 ETIQUETAS LIBRES

    Distinto de FieldSelectSearch: acá el usuario ESCRIBE lo que quiera,
    no elige de una lista. Sirve para keywords, skills o cualquier cosa
    que no tenga catálogo cerrado.

    Enter o coma agregan. Backspace con el input vacío borra la última.
    Sin librería.
*/

export const FieldTags = ({
    id, label, hint, error,
    value = [], onChange,
    placeholder = 'Escribí y presioná Enter',
    maxTags = 0, maxTagLength = 80, isDisabled = false, span = 2,
}) => {

    const [useDraft, setDraft] = useState('');

    const IS_FULL = maxTags > 0 && value.length >= maxTags;

    const onAdd = (raw) => {
        const CLEAN = raw.trim().replace(/,$/, '');
        if (!CLEAN || IS_FULL || CLEAN.length > maxTagLength) return;
        if (value.some((t) => t.toLowerCase() === CLEAN.toLowerCase())) return setDraft('');
        onChange?.([...value, CLEAN]);
        setDraft('');
    };

    const onKeyDown = (event) => {

        if (event.key === 'Enter' || event.key === ',') {
            event.preventDefault();
            return onAdd(useDraft);
        }

        if (event.key === 'Backspace' && !useDraft && value.length) {
            onChange?.(value.slice(0, -1));
        }
    };

    const DOM_NAME = useDomFieldName();

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} error={error} span={span} isDisabled={isDisabled} showHint
            hint={/enter|coma/i.test(String(hint || '')) ? hint : 'Presioná Enter o coma para agregar cada etiqueta.'} >

            <div className={`${BLOCK}__tags`} data-disabled={isDisabled}>

                {
                    value.map((tag) => (
                        <span key={tag} className={`${BLOCK}__tag`}>
                            {tag}
                            <button type="button" className={`${BLOCK}__tag_remove`}
                                aria-label={`Quitar ${tag}`} disabled={isDisabled}
                                onClick={() => onChange?.(value.filter((t) => t !== tag))} >
                                <FaTimes />
                            </button>
                        </span>
                    ))
                }

                <input name={DOM_NAME} autoComplete="nope" data-lpignore="true" data-1p-ignore="true" data-form-type="other" spellCheck={false} autoCorrect="off" autoCapitalize="off" id={DOM_ID} type="text" className={`${BLOCK}__tags_input`}
                    value={useDraft} onChange={(event) => setDraft(event.target.value)}
                    maxLength={maxTagLength || undefined}
                    onKeyDown={onKeyDown} onBlur={() => onAdd(useDraft)}
                    placeholder={IS_FULL ? '' : placeholder}
                    disabled={isDisabled || IS_FULL}
                    autoComplete={FIELD_AUTOCOMPLETE_OFF} />

            </div>

        </FieldShell>
    );
};
